
define('contato-controller',[],function() {//recaptcah


    var app = angular.module('contato.controller', [
        'ngMap',
        'contato.resource',
        'ui.mask'
    ]);

    app.controller('ContatoController', ['$scope',  'Contato', 'Default', 'NgMap',  "$timeout",
        function($scope,  Contato, Default, NgMap, $timeout) {
            $scope.possuiStreet = true;
            $scope.checkStreetView = function(){
                // var streetViewService = new google.maps.StreetViewService();
                // var lag = new google.maps.LatLng($scope.imobiliaria.imb_latitude, $scope.imobiliaria.imb_longitude);
                // streetViewService.getPanoramaByLocation(lag, 100, function (streetViewPanoramaData, status) {
                //     if (status === google.maps.StreetViewStatus.OK) {
                //         $scope.possuiStreet = true;
                //     } else {
                //         $scope.possuiStreet = false;
                //     }
                // });
            };
            $scope.imobiliaria = false;
            $scope.mapa = 'mapa';
            $scope.changeMapa = function(tipo){
                $scope.mapa = tipo;
                if(tipo == 'streetview') {
                    var obj = document.querySelector('#streetview');
                    var mapa = document.querySelector('#mapa');
                    $(mapa).fadeOut(300);
                    $(obj).fadeIn(300);

                    $scope.changeStreetView();
                }else{
                    var obj = document.querySelector('#streetview');
                    var mapa = document.querySelector('#mapa');
                    $(obj).fadeOut(300);
                    $(mapa).fadeIn(300);
                }

            };
            var imobSelected = function(imb_codigo){
                var idx = _.findIndex( $scope.imobiliarias, function(obj) {
                    return obj.imb_codigo == imb_codigo;
                });
                return $scope.imobiliarias[idx];
            };
            $scope.contato = {
                imb_codigo: null,
                imbe_codigo: null,
                nome: null,
                telefone:null,
                email:null,
                mensagem:null,
                cont_interese_contato: null,
                cont_concordo: false,
                responserecaptcha:null,
                telefonetipo: null,
            };

            $scope.msgReset = function() {
                $scope.msgSucess = '';
                $scope.msgError = '';
            }
            $scope.atualizaImobFrom = function(){
                var imb_codigo = $scope.contato.imb_codigo;
                $scope.imobiliariaForm = [];
                $scope.imobiliariaForm = imobSelected(imb_codigo);
                if($scope.imobiliariaForm.EmailImobiliaria.length > 0) {
                    $scope.imobiliariaForm.EmailImobiliaria.map(function (email) {
                        if (email.imbe_principal) {
                            $scope.contato.imbe_codigo = email.imbe_codigo;
                        }
                    });
                }
            };
            $scope.resetForm = function(){
                $scope.contato.telefonetipo = null,
                $scope.contato.nome = null;
                $scope.contato.telefone = null;
                $scope.contato.email = null;
                $scope.contato.mensagem = null;
                $scope.contato.cont_interese_contato = null;
                $scope.contato.cont_concordo = false;
                //   $scope.contato.imb_codigo = null;
                $scope.contato.responserecaptcha = null;
                $timeout(function () {
                    $scope.msgSucess = '';
                    $scope.msgError = '';
                }, 8000);
            }
            $scope.resetForm();
            var getImobiliariasContato = function(){
                var result = imobiliarias;
                result.map(function(obj, idx){
                    if(obj.imo_imb_codigo == null){
                        $scope.imobiliaria  = obj;
                        $scope.imobiliariaForm  = obj;
                        // $scope.checkStreetView();
                        $scope.contato.imb_codigo = obj.imb_codigo;
                        if(obj.EmailImobiliaria.length > 0) {
                            obj.EmailImobiliaria.map(function (email) {
                                if (email.imbe_principal) {
                                    $scope.contato.imbe_codigo = email.imbe_codigo;
                                }
                            });
                        }

                    }
                    if(obj.TelefoneImobiliaria.length > 0){
                        result[idx].tel_principal = false;
                        obj.TelefoneImobiliaria.map(function(obj2, idx2){
                            if(obj2.imbf_principal){
                                result[idx].tel_principal = obj2;
                                console.log('Telefone principal: ', result[idx].tel_principal.imbf_telefone);
                            }
                        });
                    }
                    if(obj.EmailImobiliaria.length > 0){
                        result[idx].email_principal = false;
                        obj.EmailImobiliaria.map(function(obj2, idx2){
                            if(obj2.imbe_principal){
                                result[idx].email_principal = obj2;
                            }
                        });
                    }
                });
                $scope.imobiliarias = result;
                $scope.$watch('imb_codigo', function(){
                    if(typeof $scope.imb_codigo != 'undefined') {
                        $scope.atualizaImobFrom();
                    }
                });
            };
            getImobiliariasContato();
            $scope.atualizaMap = function(imb_codigo){
                $scope.imobiliaria = imobSelected(imb_codigo);
                $scope.changeStreetView();
                $scope.checkStreetView();
            }
            $scope.changeStreetView = function(){
                var obj = document.querySelector('#streetview');
                var lag = new google.maps.LatLng($scope.imobiliaria.imb_latitude,$scope.imobiliaria.imb_longitude);
                var pov = {
                    heading: parseFloat($scope.imobiliaria.imb_heading),
                    pitch:parseFloat($scope.imobiliaria.imb_pitch),
                    zoom: parseFloat($scope.imobiliaria.imb_zoom)
                };
                var _options = {
                    position:lag,
                    pov: pov
                }
                new google.maps.StreetViewPanorama(obj, _options);
                var streetViewService = new google.maps.StreetViewService();
                streetViewService.getPanoramaByLocation(lag, 100, function (streetViewPanoramaData, status) {
                    if (status === google.maps.StreetViewStatus.OK) {
                    } else {
                        // no street view available in this range, or some error occurred
                    }
                });
            }
            $scope.msgSucess = '';
            $scope.msgError = '';
            $scope.resolveCaptcha = true;
            $scope.enviaEmail = function(form){
                if( $scope.contato.responserecaptcha === ""){
                    $scope.resolveCaptcha = false;
                    return false;
                }else {
                    $scope.resolveCaptcha = true;
                    console.log(form)
                    console.log($scope.contato);
                    
                    if (form.$valid && $scope.contato.cont_interese_contato != null) {
                        $("#ajaxbloq").fadeIn();
                        var obj = {
                            imbe_codigo: $scope.contato.imbe_codigo,
                            telefone: $scope.contato.telefone,
                            email: $scope.contato.email,
                            mensagem: $scope.contato.mensagem,
                            nome: $scope.contato.nome,
                            cont_interese_contato: $scope.contato.cont_interese_contato,
                            cont_concordo: $scope.contato.cont_concordo,
                            recaptcharesponse:$scope.contato.responserecaptcha
                        };
                        // $scope.msgSucess = 'Mensagem Enviada com sucesso!';
                        //  $scope.msgError = '';
                        //  $scope.resetForm();
                        //  form.$setPristine();
                        Contato.enviaEmail(obj).then(function (result) {
                            if (result.data.ok) {
                                $scope.msgSucess = 'Mensagem Enviada com sucesso!';
                                $scope.msgError = '';
                                $scope.resetForm();
                                form.$setPristine();
                                $scope.cbExpiration();
                            } else {
                                $scope.msgSucess = '';
                                $scope.msgError = 'Mensagem não pode ser enviada tente mais tarde!';
                                $scope.resetForm();
                                form.$setPristine();
                                if(result.data.novalidate){
                                    $scope.msgError = 'Mensagem não pode ser enviada tente mais tarde, captcha não validado!';
                                }
                            }
                            $timeout(function () {
                                $("#msgInfo").fadeOut('slow', function () {
                                    $scope.msgSucess = '';
                                    $scope.msgError = '';
                                });
                            }, 5000);
                            $scope.resetForm();
                            $("#ajaxbloq").fadeOut();
                        });
                    } else {
                        angular.forEach(form.$error.required, function (value, key) {
                            form.$error.required[key].$pristine = false;
                        });
                    }
                }
            }
            /*
             Recaptcha
             */
            $scope.response = null;
            $scope.widgetId = null;
            $scope.recaptcha = {
                key: '6Le2PxkTAAAAABJWPWIkLPa9QJ-J40XaiZkANGTC'//chave do cliente de segurança
            };
            $scope.setResponse = function (response) {
                $scope.contato.responserecaptcha = response;
            };
            $scope.setWidgetId = function (widgetId) {
                $scope.widgetId = widgetId;
            };
            $scope.cbExpiration = function() {
                vcRecaptchaService.reload($scope.widgetId);
                $scope.contato.responserecaptcha = null;
            };
        }]);
});

